import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import('../views/home')

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const titlename = ' | ARIT RMUTL'

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { title: 'นักศึกษา', group_id: 1, menu_id: 1, description: 'แบบสำรวจความพร้อมการจัดกิจกรรมการเรียนการสอนผ่านระบบออนไลน์ ปีการศึกษา 2563' }
    }
  ]
})

const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js